import { FieldProps, IChangeEvent } from "@rjsf/core";

/**
 * Default props for rsjf FieldProps
 */
export const DefaultFieldProps: FieldProps = {
    schema: {},
    uiSchema: {},
    idSchema: { "$id": "" } as any,
    formData: "",
    formContext: null,
    errorSchema: {},
    autofocus: false,
    disabled: false,
    readonly: false,
    required: false,
    name: "",
    registry: {
        rootSchema: {},
        fields: {  },
        widgets: {  },
        definitions: {  },
        formContext: null,
    },
    onChange: (e: IChangeEvent) => e,
    onBlur: (id: string, value: boolean | number | string | null) => id,
    onFocus: (id: string, value: any) => { return; }
}
